import { useGameStore } from '../store';
import type { StockSymbol } from '../types';

const TABS: Array<{ sym: StockSymbol; label: string; vol: '低' | '中' | '高' }> = [
  { sym: 'CHJ', label: '🏺 청자방', vol: '低' },
  { sym: 'BDS', label: '🧵 비단상단', vol: '中' },
  { sym: 'HYB', label: '🧨 화약방', vol: '高' },
];

export default function StockTabs() {
  const sym = useGameStore((s) => s.sym);
  const hasPos = useGameStore((s) => s.position !== null);
  const selectStock = useGameStore((s) => s.selectStock);
  const openLabor = useGameStore((s) => s.openLabor);

  return (
    <div id="stock-tabs">
      <div
        className="stock-tab"
        onClick={openLabor}
        style={{ opacity: hasPos ? 0.4 : 1, pointerEvents: hasPos ? 'none' : 'auto' }}
      >
        ⛏️ 노역
      </div>
      {TABS.map((t) => (
        <div
          key={t.sym}
          className={`stock-tab${sym === t.sym ? ' active' : ''}`}
          onClick={() => selectStock(t.sym)}
          style={{ opacity: hasPos ? 0.4 : 1, pointerEvents: hasPos ? 'none' : 'auto' }}
        >
          {t.label}
          <span className="vol-badge">{t.vol}</span>
        </div>
      ))}
    </div>
  );
}
